// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/whoop-02.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-logo-mp{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.whoop-mp{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat
}


@media (min-width: 1400){
    .ant-card-cover {
        min-height: 500px !important;
    }
}

#map2 .ol-zoom .ol-zoom-out {
    margin-top: 204px;
}

.ol-scale-line {
    left: 90%;
    position: absolute;
    bottom: 10px;
    color: white !important;
    background: rgba(51, 4, 112, 0.9) !important;
}

@media (max-width: 850px) {
    .ol-scale-line {
        left: 80%;
        position: absolute;
        bottom: 10px;
        color: white !important;
        background: rgba(51, 4, 112, 0.9) !important;
    }
}

@media (max-width: 450px) {
    .ol-scale-line {
        left: 72%;
        position: absolute;
        bottom: 10px;
        color: white !important;
        background: rgba(51, 4, 112, 0.9) !important;
    }
}

.ol-scale-line > div {
    color: #fff !important;
}

/* Morpho Chat drawer owns the right edge: zoom stack + scale bar move next to the left icon rail. */
body.morpho-chat-open #right-bottom-apps {
    right: auto !important;
    left: 64px !important;
    left: var(--morpho-chrome-left, 64px) !important;
}

body.morpho-chat-open #right-bottom-apps > .MuiStack-root {
    flex-direction: row !important;
}

body.morpho-chat-open .ol-scale-line {
    left: 64px !important;
    left: var(--morpho-chrome-left, 64px) !important;
    right: auto !important;
}

#map2 .ol-zoomslider {
    background-color: transparent;
    top: 36px;
}

#map2 .ol-touch .ol-zoom .ol-zoom-out {
	margin-top: 212px;
}
#map2 .ol-touch .ol-zoomslider {
  top: 44px;
}

.ol-zoom .ol-zoom-in {
  width: 40% !important;
}

.ol-zoom .ol-zoom-out {
  width: 40% !important;
}

#map2 .ol-zoom-in.ol-has-tooltip:hover [role=tooltip],
#map2 .ol-zoom-in.ol-has-tooltip:focus [role=tooltip] {
  top: 3px;
}

#map2 .ol-zoom-out.ol-has-tooltip:hover [role=tooltip],
#map2 .ol-zoom-out.ol-has-tooltip:focus [role=tooltip] {
  top: 232px;
}

.ol-popup {
  position: absolute;
  background-color: white;
  filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
  padding: 15px;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 280px;
}

.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: relative;
  left: 95%;
}
.ol-popup-closer:after {
  content: "✖";
}

.ant-list-header, .ant-list-footer{
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  font-size: 13px !important;
  font-weight: bolder !important;
}

.morphle-title {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  font-size: 16px !important;
  text-align: center;
  margin-bottom: 56px;
}

#fs-mp-0 {
  text-align: center
}

.upload-list-inline .ant-upload-list-item {
  float: left;
  width: "50%";
  margin-right: 8px;
  background: #ffffffff !important;
}

.upload-list-inline .ant-upload-list-item:hover {
  background: #d6d7e4 !important;
}

.caseViewSlideItem {
  float: left;
  width: "100%";
  margin-right: 8px;
  background: #ffffffff !important;
  position: relative;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.caseViewSlideItem:hover {
  background: #d6d7e4 !important;
}

.ant-upload {
  cursor: pointer !important
}

.icon-hover:hover {
  display: inline-flex;
  border-radius: 10%;
  background-color: #FFFFFF;
  transform:scale(1.1);
  -moz-transform:scale(1.1);
  -webkit-transform:scale(1.1);
  -ms-transform:scale(1.1);
  -o-transform:scale(1.1);
}

.rotate270 {
  transform: rotate(270deg);
}

.scroll-slide-list-modal {
  max-height: 150px;
  overflow-y: scroll;
}

.custom-button-style, .custom-button-style:hover {
  background-repeat: no-repeat;
  background-position: right 7px center;
  display: block;
  padding: 3px 12px;
  font-weight: 400;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #fff;
  border-radius: 5px;
}

.custom-button-background {
  background-color: #999;
}

.custom-button-background:hover {
  background-color: #417690;
}

.align-right {
  align-content: right;
}

.disable-button-present-mode .ant-btn-disabled, .ant-btn.disabled, .ant-btn[disabled], .ant-btn-disabled:hover, .ant-btn.disabled:hover, .ant-btn[disabled]:hover, .ant-btn-disabled:focus, .ant-btn.disabled:focus, .ant-btn[disabled]:focus, .ant-btn-disabled:active, .ant-btn.disabled:active, .ant-btn[disabled]:active, .ant-btn-disabled.active, .ant-btn.disabled.active, .ant-btn[disabled].active {
  color: rgba(0, 0, 0, 0.8);
  background-color: #ffffff;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}

.selected-scan-message {
    -webkit-font-smoothing: antialiased;
    font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: 10px;
    letter-spacing: .2px;
    align-items: center;
    background-color: rgba(241,243,244,0.871);
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
    color: #5f6368;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 4px 0;
    min-height: 48px;
    padding: 6px 16px;
}

.select-all-scans-message, .select-all-scans-message:hover {
    align-items: center;
    border: none;
    display: inline-flex;
    justify-content: center;
    outline: none;
    position: relative;
    z-index: 0;
    -webkit-font-smoothing: antialiased;
    font-family: 'Google Sans', Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-size: 10px;
    letter-spacing: .25px;
    background: none;
    border-radius: 4px;
    box-sizing: border-box;
    color: #5f6368;
    cursor: pointer;
    font-weight: 500;
    height: 36px;
    min-width: 80px;
    outline: none;
    color: #1a73e8;
    margin-left: 4px;
    padding: 0 8px;
    text-decoration: none;
    white-space: pre-wrap;
}

.select-all-scans-message:hover {
    text-decoration: underline;
}

.last-updated-info {
    position: absolute;
    top: 1px;
    right: 20px;
    padding-left: 10px;
    padding-right: 5px;
    background-color: rgb(203, 195, 227, 0.6);
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin-top: 50px !important;
}

.row-color-red {
  background-color: red;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/style.css"],"names":[],"mappings":"AAAA;IACI,yDAAsC;AAC1C;;AAEA;IACI,yDAA0C;IAC1C,2BAA2B;IAC3B,wBAAwB;IACxB;AACJ;;;AAGA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,4CAA4C;AAChD;;AAEA;IACI;QACI,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,uBAAuB;QACvB,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,uBAAuB;QACvB,4CAA4C;IAChD;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,oGAAoG;AACpG;IACI,sBAAsB;IACtB,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;IAChD,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,SAAS;AACb;;AAEA;CACC,iBAAiB;AAClB;AACA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,QAAQ;AACV;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,8CAA8C;EAC9C,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;IACI,mCAAmC;IACnC,0DAA0D;IAC1D,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,mCAAmC;IACnC,yEAAyE;IACzE,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".login-logo-mp{\n    background-image: url(../img/logo.png);\n}\n\n.whoop-mp{\n    background-image: url(../img/whoop-02.png);\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat\n}\n\n\n@media (min-width: 1400){\n    .ant-card-cover {\n        min-height: 500px !important;\n    }\n}\n\n#map2 .ol-zoom .ol-zoom-out {\n    margin-top: 204px;\n}\n\n.ol-scale-line {\n    left: 90%;\n    position: absolute;\n    bottom: 10px;\n    color: white !important;\n    background: rgba(51, 4, 112, 0.9) !important;\n}\n\n@media (max-width: 850px) {\n    .ol-scale-line {\n        left: 80%;\n        position: absolute;\n        bottom: 10px;\n        color: white !important;\n        background: rgba(51, 4, 112, 0.9) !important;\n    }\n}\n\n@media (max-width: 450px) {\n    .ol-scale-line {\n        left: 72%;\n        position: absolute;\n        bottom: 10px;\n        color: white !important;\n        background: rgba(51, 4, 112, 0.9) !important;\n    }\n}\n\n.ol-scale-line > div {\n    color: #fff !important;\n}\n\n/* Morpho Chat drawer owns the right edge: zoom stack + scale bar move next to the left icon rail. */\nbody.morpho-chat-open #right-bottom-apps {\n    right: auto !important;\n    left: 64px !important;\n    left: var(--morpho-chrome-left, 64px) !important;\n}\n\nbody.morpho-chat-open #right-bottom-apps > .MuiStack-root {\n    flex-direction: row !important;\n}\n\nbody.morpho-chat-open .ol-scale-line {\n    left: 64px !important;\n    left: var(--morpho-chrome-left, 64px) !important;\n    right: auto !important;\n}\n\n#map2 .ol-zoomslider {\n    background-color: transparent;\n    top: 36px;\n}\n\n#map2 .ol-touch .ol-zoom .ol-zoom-out {\n\tmargin-top: 212px;\n}\n#map2 .ol-touch .ol-zoomslider {\n  top: 44px;\n}\n\n.ol-zoom .ol-zoom-in {\n  width: 40% !important;\n}\n\n.ol-zoom .ol-zoom-out {\n  width: 40% !important;\n}\n\n#map2 .ol-zoom-in.ol-has-tooltip:hover [role=tooltip],\n#map2 .ol-zoom-in.ol-has-tooltip:focus [role=tooltip] {\n  top: 3px;\n}\n\n#map2 .ol-zoom-out.ol-has-tooltip:hover [role=tooltip],\n#map2 .ol-zoom-out.ol-has-tooltip:focus [role=tooltip] {\n  top: 232px;\n}\n\n.ol-popup {\n  position: absolute;\n  background-color: white;\n  filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));\n  padding: 15px;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-radius: 10px;\n  border: 1px solid #cccccc;\n  bottom: 12px;\n  left: -50px;\n  min-width: 280px;\n}\n\n.ol-popup:after, .ol-popup:before {\n  top: 100%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.ol-popup:after {\n  border-top-color: white;\n  border-width: 10px;\n  left: 48px;\n  margin-left: -10px;\n}\n.ol-popup:before {\n  border-top-color: #cccccc;\n  border-width: 11px;\n  left: 48px;\n  margin-left: -11px;\n}\n.ol-popup-closer {\n  text-decoration: none;\n  position: relative;\n  left: 95%;\n}\n.ol-popup-closer:after {\n  content: \"✖\";\n}\n\n.ant-list-header, .ant-list-footer{\n  padding-top: 6px !important;\n  padding-bottom: 6px !important;\n  font-size: 13px !important;\n  font-weight: bolder !important;\n}\n\n.morphle-title {\n  padding-top: 6px !important;\n  padding-bottom: 6px !important;\n  font-size: 16px !important;\n  text-align: center;\n  margin-bottom: 56px;\n}\n\n#fs-mp-0 {\n  text-align: center\n}\n\n.upload-list-inline .ant-upload-list-item {\n  float: left;\n  width: \"50%\";\n  margin-right: 8px;\n  background: #ffffffff !important;\n}\n\n.upload-list-inline .ant-upload-list-item:hover {\n  background: #d6d7e4 !important;\n}\n\n.caseViewSlideItem {\n  float: left;\n  width: \"100%\";\n  margin-right: 8px;\n  background: #ffffffff !important;\n  position: relative;\n  padding: 8px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n}\n\n.caseViewSlideItem:hover {\n  background: #d6d7e4 !important;\n}\n\n.ant-upload {\n  cursor: pointer !important\n}\n\n.icon-hover:hover {\n  display: inline-flex;\n  border-radius: 10%;\n  background-color: #FFFFFF;\n  transform:scale(1.1);\n  -moz-transform:scale(1.1);\n  -webkit-transform:scale(1.1);\n  -ms-transform:scale(1.1);\n  -o-transform:scale(1.1);\n}\n\n.rotate270 {\n  transform: rotate(270deg);\n}\n\n.scroll-slide-list-modal {\n  max-height: 150px;\n  overflow-y: scroll;\n}\n\n.custom-button-style, .custom-button-style:hover {\n  background-repeat: no-repeat;\n  background-position: right 7px center;\n  display: block;\n  padding: 3px 12px;\n  font-weight: 400;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #fff;\n  border-radius: 5px;\n}\n\n.custom-button-background {\n  background-color: #999;\n}\n\n.custom-button-background:hover {\n  background-color: #417690;\n}\n\n.align-right {\n  align-content: right;\n}\n\n.disable-button-present-mode .ant-btn-disabled, .ant-btn.disabled, .ant-btn[disabled], .ant-btn-disabled:hover, .ant-btn.disabled:hover, .ant-btn[disabled]:hover, .ant-btn-disabled:focus, .ant-btn.disabled:focus, .ant-btn[disabled]:focus, .ant-btn-disabled:active, .ant-btn.disabled:active, .ant-btn[disabled]:active, .ant-btn-disabled.active, .ant-btn.disabled.active, .ant-btn[disabled].active {\n  color: rgba(0, 0, 0, 0.8);\n  background-color: #ffffff;\n  border-color: #d9d9d9;\n  text-shadow: none;\n  box-shadow: none;\n}\n\n.selected-scan-message {\n    -webkit-font-smoothing: antialiased;\n    font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;\n    font-size: 10px;\n    letter-spacing: .2px;\n    align-items: center;\n    background-color: rgba(241,243,244,0.871);\n    border: none;\n    border-radius: 4px;\n    box-sizing: border-box;\n    color: #5f6368;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin: 4px 0;\n    min-height: 48px;\n    padding: 6px 16px;\n}\n\n.select-all-scans-message, .select-all-scans-message:hover {\n    align-items: center;\n    border: none;\n    display: inline-flex;\n    justify-content: center;\n    outline: none;\n    position: relative;\n    z-index: 0;\n    -webkit-font-smoothing: antialiased;\n    font-family: 'Google Sans', Roboto,RobotoDraft,Helvetica,Arial,sans-serif;\n    font-size: 10px;\n    letter-spacing: .25px;\n    background: none;\n    border-radius: 4px;\n    box-sizing: border-box;\n    color: #5f6368;\n    cursor: pointer;\n    font-weight: 500;\n    height: 36px;\n    min-width: 80px;\n    outline: none;\n    color: #1a73e8;\n    margin-left: 4px;\n    padding: 0 8px;\n    text-decoration: none;\n    white-space: pre-wrap;\n}\n\n.select-all-scans-message:hover {\n    text-decoration: underline;\n}\n\n.last-updated-info {\n    position: absolute;\n    top: 1px;\n    right: 20px;\n    padding-left: 10px;\n    padding-right: 5px;\n    background-color: rgb(203, 195, 227, 0.6);\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    margin-top: 50px !important;\n}\n\n.row-color-red {\n  background-color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
